<script lang="ts">
import { defineComponent } from "vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import { inputChangeHandler } from "@/businesslogic/utils/events";
import anredeUtils from "@/businesslogic/utils/anredeUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Anrede",
  methods: { inputChangeHandler },
  components: { ValidierungsFehler },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: true,
    },
    fehler: Object,
    istVerwalter: {
      type: Boolean,
      required: false,
      default: false,
    },
    personenAnrede: {
      type: Boolean,
      required: false,
      default: true,
    },
    firmenAnrede: {
      type: Boolean,
      required: false,
      default: true,
    },
    gemeinschaftsAnrede: {
      type: Boolean,
      required: false,
      default: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    tabindex: {
      type: String,
      required: false,
    },
    autofocus: {
      type: Boolean,
      required: false,
    },
  },
  setup() {
    const piniaStore = useFormStore();
    const { wegAnredeErlaubt, etgAnredeErlaubt, firmaAnredeErlaubt, personAnredeErlaubt } = anredeUtils();

    return {
      piniaStore,
      wegAnredeErlaubt,
      etgAnredeErlaubt,
      firmaAnredeErlaubt,
      personAnredeErlaubt,
    };
  },
});
</script>

<template>
  <select
    :id="id"
    :name="id"
    :value="modelValue"
    class="c-form-control-select"
    data-cy="anrede"
    data-fehlermeldung="Bitte wählen Sie eine Anrede aus."
    :required="required"
    :aria-required="required"
    :aria-label="ariaLabel"
    :autofocus="autofocus"
    :tabindex="tabindex"
    @input="$emit('update:modelValue', inputChangeHandler($event))"
  >
    <option
      v-if="
        istVerwalter ||
        personAnredeErlaubt(piniaStore.state, istVerwalter) ||
        firmaAnredeErlaubt(piniaStore.state, istVerwalter) ||
        (etgAnredeErlaubt(piniaStore.state, istVerwalter) && wegAnredeErlaubt(piniaStore.state, istVerwalter))
      "
      value=""
    >
      Bitte wählen
    </option>
    <option v-if="personAnredeErlaubt(piniaStore.state, istVerwalter) && personenAnrede" value="0001">Frau</option>
    <option v-if="personAnredeErlaubt(piniaStore.state, istVerwalter) && personenAnrede" value="0002">Herr</option>
    <option v-if="personAnredeErlaubt(piniaStore.state, istVerwalter) && personenAnrede" value="Z001">Divers</option>
    <option v-if="firmaAnredeErlaubt(piniaStore.state, istVerwalter) && firmenAnrede" value="0003">Firma</option>
    <option v-if="etgAnredeErlaubt(piniaStore.state, istVerwalter) && gemeinschaftsAnrede" value="ETG">
      Eigentümergemeinschaft (EG)
    </option>
    <option v-if="wegAnredeErlaubt(piniaStore.state, istVerwalter) && gemeinschaftsAnrede" value="WEG">
      Wohnungseigentümergemeinschaft (WEG)
    </option>
  </select>
  <validierungs-fehler v-if="fehler" :fehler-text="fehler[id]" :reduzierter-abstand="true" />
</template>

<style scoped></style>
